import React, { useEffect, useState } from "react";
import { Button, Typography, Tooltip } from "@mui/material";
import { Add as AddIcon } from "@mui/icons-material";
import { AnimatePresence } from "framer-motion";
import {
  useCreateData,
  useDeleteTableDataPreset,
  useGetTableData2,
} from "../Plan/tableHooks";
import NewPresetForm from "./NewPresetForm";
import PresetCard from "./PresetCard";
import * as S from "./styles";
import goToHelpLink from "../../../utils/goToHelpLink";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import axios from "axios";
import TPC_URL from "../../../utils/TPC_URL";

function Preset({ openSnackbar, group_code, project_code }) {
  const [shiftsData, setShiftsData] = useState([]);
  const [isCreating, setIsCreating] = useState(false);
  const [editingPreset, setEditingPreset] = useState(null);
  const { presets } = useGetTableData2(
    true,
    `/api/factory/getTypeM?group_code=${group_code}&project_code=${project_code}`,
    "presets"
  );
  const createMutation = useCreateData(
    true,
    "/api/factory/createPreset",
    openSnackbar
  );
  const editMutation = useCreateData(
    true,
    "/api/factory/postType",
    openSnackbar
  );
  const deletePresetMutation = useDeleteTableDataPreset(
    true,
    "/api/factory/deletePreset",
    true
  );
  useEffect(() => {
    async function fetchData() {
      try {
        const response = await axios.get(
          `${TPC_URL}/api/shift/getAllShifts?group_code=${group_code}&project_code=${project_code}`
        );
        if (response.data && Array.isArray(response.data)) {
          setShiftsData(response.data);
        } else {
          setShiftsData([]);
        }
      } catch (error) {
        console.error("Error fetching preset data:", error);
      }
    }
    fetchData();
  }, [group_code, project_code]);
  return (
    <S.PageWrapperPreset maxWidth={false}>
      <S.HeaderPreset>
        <div style={{ display: "flex", alignItems: "center" }}>
          <Typography
            sx={{
              fontWeight: "700",
              fontSize: "22px !important",
              color: "#111",
            }}
          >
            근무시간 유형 설정&nbsp;
          </Typography>
          <Tooltip
            title="이동"
            sx={{ cursor: "pointer" }}
            onClick={() =>
              goToHelpLink(
                "https://help.ese-tech.com/ko/scheduler#h-9-1-%ED%94%84%EB%A6%AC%EC%85%8B-%EC%84%A4%EC%A0%95"
              )
            }
          >
            <HelpOutlineIcon />
          </Tooltip>
        </div>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => setIsCreating(true)}
          disabled={isCreating}
        >
          근무시간 유형 등록
        </Button>
      </S.HeaderPreset>
      <S.PresetsList>
        <AnimatePresence>
          {isCreating && (
            <NewPresetForm
              createMutation={createMutation}
              setIsCreating={setIsCreating}
              openSnackbar={openSnackbar}
              group_code={group_code}
              project_code={project_code}
              shiftsData={shiftsData}
            />
          )}
        </AnimatePresence>
        {presets
          .filter((preset) => preset.id > 0)
          .map((preset) => (
            <PresetCard
              key={preset.id}
              preset={preset}
              editingPreset={editingPreset}
              setEditingPreset={setEditingPreset}
              editMutation={editMutation}
              deletePresetMutation={deletePresetMutation}
              openSnackbar={openSnackbar}
              group_code={group_code}
              project_code={project_code}
              shiftsData={shiftsData}
            />
          ))}
      </S.PresetsList>
    </S.PageWrapperPreset>
  );
}

export default Preset;
